import { render, staticRenderFns } from "./TeamsButton.vue?vue&type=template&id=09b56d2a"
import script from "./TeamsButton.vue?vue&type=script&lang=js"
export * from "./TeamsButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports